import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { DragLayer as dragLayer } from 'react-dnd';
import _ from 'lodash';
import { AC_NODETYPE_DEFINITION } from './AutocodeConstants';
import AC_GRID from './AutocodeTypes';
import AutocodeSelectionContext from './ACContext/ACSelectionBoxContext';
import AutocodeLabelsGenerator, {
  ACStandardLabels,
} from './AutocodeLabelsGenerator';
import { useSelector } from '../common/react-redux-hooks';

const collect = monitor => {
  return {
    item: monitor.getItem(),
    initialOffset: monitor.getInitialSourceClientOffset(),
    currentOffset: monitor.getClientOffset(), // monitor.getSourceClientOffset(),
    isDragging: monitor.isDragging(),
  };
};

const layerStyles = {
  position: 'fixed',
  pointerEvents: 'none',
  zIndex: 200,
  left: 0,
  top: 0,
  width: '20%',
  height: '100%',
};

const getItemStyles = props => {
  const { currentOffset } = props;
  if (!currentOffset) {
    return {
      display: 'none',
    };
  }

  const { x, y } = currentOffset;

  const transform = `translate(${x}px, ${y}px)`;

  return {
    transform,
    WebkitTransform: transform,
  };
};

const getListStyles = () => {
  return {
    backgroundColor: '#c1cdda',
    border: '1px solid #E4E4E4',
    marginBottom: '5px',
    paddingLeft: '3px',
    cursor: 'move !important',
    fontSize: '12px',
    overflowX: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
  };
};

const AutocodeCustomDragLayer = props => {
  const { items, type, isDragging } = props;

  const acSelContext = useContext(AutocodeSelectionContext);
  const { toLabelString } = AutocodeLabelsGenerator(ACStandardLabels, null);
  const { partsToShow } = useSelector(state => ({
    partsToShow: state.crosstab.partsToShow,
  }));

  if (!isDragging) {
    return false;
  }

  const buildSelBoxDragView = (item, i) => {
    if (item.type === AC_NODETYPE_DEFINITION) {
      return (
        <div style={getListStyles()} key={i}>
          {item.data.title}
        </div>
      );
    }
    return (
      <div style={getListStyles()} key={i}>
        {item.toLabelString(acSelContext.state.partsToShow, true)}
      </div>
    );
  };

  const buildGridDragView = (item, i) => {
    return (
      <div style={getListStyles()} key={i}>
        {/* {item.originalTitle} */}
        {toLabelString(item.dataSmartSearch.autocodenode, partsToShow)}
      </div>
    );
  };

  const singleListDragView = (item, i) => {
    return (
      <div style={getListStyles()} key={i}>
        {item.shortText}
      </div>
    );
  };

  const doubleListDragView = (item, i) => {
    return (
      <div style={getListStyles()} key={i}>
        {item.shortText}
      </div>
    );
  };

  const template1CategoryDragView = (item, i) => {
    return (
      <div style={getListStyles()} key={i}>
        {item.dragText}
      </div>
    );
  };

  const acDefSingleListDragView = (item, i) => {
    return (
      <div style={getListStyles()} key={i}>
        {item.title}
      </div>
    );
  };

  const renderSwitch = param => {
    switch (param) {
      case AC_GRID.AC_GRID_2:
        return _.map(items, (item, i) => buildSelBoxDragView(item, i));
      case AC_GRID.AC_TEMPLATE_SINGLE_LIST:
        return _.map(items, (item, i) => singleListDragView(item, i));
      case AC_GRID.AC_TEMPLATE_1_CATEGORY:
        return _.map(items, (item, i) => template1CategoryDragView(item, i));
      case AC_GRID.AC_TEMPLATE_DOUBLE_LIST:
        return _.map(items, (item, i) => doubleListDragView(item, i));
      case AC_GRID.AC_DEFINITIONS:
        return _.map(items, (item, i) => acDefSingleListDragView(item, i));
      default:
        return _.map(items, (item, i) => buildGridDragView(item, i));
    }
  };
  return (
    <div style={layerStyles}>
      <div style={getItemStyles(props)}>
        {/* <ul>{_.map(items, (item, i) => buildDragView(item, i))}</ul> */}
        <div className="row">
          <div className="dragged-preview-grid">{renderSwitch(type)}</div>
        </div>
      </div>
    </div>
  );
};

AutocodeCustomDragLayer.propTypes = {
  items: PropTypes.arrayOf(PropTypes.object),
  isDragging: PropTypes.bool,
  type: PropTypes.func,
};

export default dragLayer(collect)(AutocodeCustomDragLayer);
